import { IEventEventProviderParams } from 'lib/EventsProvider/@types';

enum IE_CREATE_BABY_KINEDU_TYPE {
  KINEDU = 'kinedu',
  NBY = 'nby',
}

enum IE_LOAD_DEFAULT_PAYWALL_FOLDER {
  BORN = 'paywall_web',
  NBY = 'paywall_web_nby',
}

enum IE_PP_PAYMENT_STARTED_PROVIDER {
  STRIPE = 'stripe',
  PAYPAL = 'paypal',
}

type IPP_PAYMENT_STARTED = IEventEventProviderParams & {
  provider: IE_PP_PAYMENT_STARTED_PROVIDER;
};

export { IE_CREATE_BABY_KINEDU_TYPE, IE_LOAD_DEFAULT_PAYWALL_FOLDER, IE_PP_PAYMENT_STARTED_PROVIDER };
export type { IPP_PAYMENT_STARTED };
